import { DashboardUtils } from "../dashboard_utils";

export function NewPageBlurb(props: {
	onClick: () => void;
	title: string;
	description: string;
	is_new?: boolean;
}) {
	return (
		<div
			className="field group cursor-pointer transition-all hover:!border-sesh-dark"
			onClick={props.onClick}
		>
			<div className="flex items-center gap-2">
				<div>
					{DashboardUtils.CreateHeaderAndInfoButton(
						props.title,
						props.description,
						false,
						false,
						false,
						undefined,
						false,
						props.is_new
					)}
				</div>
				<div className="ml-auto text-xl text-sesh-primary transition-all group-hover:text-sesh-dark">
					<i className="fas fa-chevron-right"></i>
				</div>
			</div>
		</div>
	);
}
